// Leaflet 1.7+ throws "Cannot use 'in' operator to search for '_leaflet_id' in undefined" when
// removeLayer() / hasLayer() is called with undefined or null. Leaflet 1.6 (what the old
// webpack build used) treated that as a no-op, and this app relies on it all over the map code
// (e.g. `layerGroup.removeLayer(marker.driverLine)` where the line may not exist). Without this,
// the first such call throws and aborts the rest of the update: pins stay on the driver map
// (the shop pin never swaps for the customer pin on pickup, cancelled/accepted jobs keep their
// pins) and dispatcher/ride maps leave stale markers.
import L from "leaflet";

function noopWhenMissing(proto, name, missingResult) {
  var original = proto[name];
  if (!original || original.__leafletCompat) return;
  var patched = function (layer) {
    if (layer === undefined || layer === null) {
      return missingResult === "this" ? this : missingResult;
    }
    return original.apply(this, arguments);
  };
  patched.__leafletCompat = true;
  proto[name] = patched;
}

noopWhenMissing(L.LayerGroup.prototype, "removeLayer", "this");
noopWhenMissing(L.LayerGroup.prototype, "hasLayer", false);
noopWhenMissing(L.FeatureGroup.prototype, "removeLayer", "this");
noopWhenMissing(L.Map.prototype, "removeLayer", "this");
noopWhenMissing(L.Map.prototype, "hasLayer", false);

export default L;
